import React from 'react'
import "../../styles/shared/error.css";
import errorImage from "../../assets/icon/nothing.png";

function NotFound() {
  return (
    <div className="error-wrapper">
      <img src={errorImage} alt="error" className="error-image" />
      <h2 className="error-title">Axtardığınız resurs mövcud deyil.</h2>
    </div>
  )
}

export default NotFound